export const SERVER_LINK = 'https://admin.dimolosound.com';

// export const SERVER_LINK = 'http://localhost:1338';